module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAQAAAD9CzEMAAAAc0lEQVR4Ae2XAQaAQBBF3xVCqdvXFUpHqrC7Z5ggYBB2aOO/Bww8mMEgmmJkI2OVZjZG8PScWJAXHY4ZC3TBkUIDCYc9xs8VUOB/gSgVeFVrqoACjV6yAlpTBRQ4sECPD16oIfAJPOnBM7FTsEoLKxOiIW7sIu076nXQ3QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/Menucontainer/baseline_grid_on_black_24dp.png
// module id = 64
// module chunks = 0